<template>
  <div>
    <div class="d-flex justify-center align-center" v-if="cargando">
      <v-progress-circular indeterminate color="primary" class="mb-3" size="48" />
    </div>

    <v-alert v-if="!cargando && items.length === 0" type="info" dense text class="mb-0">
      No se encontraron precios para los parámetros seleccionados.
    </v-alert>

    <v-card v-if="!cargando && items.length > 0" outlined>
      <v-card-text class="pa-0" style="overflow-x: auto">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <!-- Fila 1: grupos -->
              <tr>
                <th
                  rowspan="2"
                  class="grey lighten-3 text-center"
                  style="vertical-align: middle; min-width: 220px">
                  TIPO PRECIO
                </th>

                <template v-for="(concepto, cIdx) in conceptosUnicos">
                  <th
                    :key="'h1-' + cIdx"
                    colspan="3"
                    class="text-center"
                    :class="cIdx % 2 === 0 ? 'amber lighten-4' : 'orange lighten-4'">
                    {{ concepto }}
                  </th>
                </template>

                <!-- Resumen CONTADO -->
                <th
                  :colspan="2 + conceptosUnicos.length"
                  class="text-center green lighten-4 green--text text--darken-2">
                  CONTADO
                </th>

                <!-- Resumen CRÉDITO -->
                <th :colspan="2 + conceptosUnicos.length" class="text-center blue lighten-4 blue--text text--darken-2">
                  CRÉDITO
                </th>
              </tr>

              <!-- Fila 2: sub-headers -->
              <tr>
                <!-- Sub-headers conceptos -->
                <template v-for="(concepto, cIdx) in conceptosUnicos">
                  <th
                    :key="'h2-m-' + cIdx"
                    class="text-right text-caption"
                    style="min-width: 110px"
                    :class="cIdx % 2 === 0 ? 'amber lighten-5' : 'orange lighten-5'">
                    Monto
                  </th>
                  <th
                    :key="'h2-c-' + cIdx"
                    class="text-right text-caption"
                    style="min-width: 110px"
                    :class="cIdx % 2 === 0 ? 'amber lighten-5' : 'orange lighten-5'">
                    N° Cuotas / Módulos
                  </th>
                  <th
                    :key="'h2-t-' + cIdx"
                    class="text-right text-caption"
                    style="min-width: 100px"
                    :class="cIdx % 2 === 0 ? 'amber lighten-5' : 'orange lighten-5'">
                    Total
                  </th>
                </template>

                <!-- Sub-headers resumen CONTADO -->
                <th class="text-right text-caption green lighten-5">Plan</th>
                <template v-for="(concepto, cIdx) in conceptosUnicos">
                  <th :key="'contado-h2-d-' + cIdx" class="text-right text-caption green lighten-5" style="min-width: 130px">
                    % Desc. {{ concepto }}
                  </th>
                </template>
                <th class="text-right text-caption green lighten-5 font-weight-bold">Precio Mín.</th>

                <!-- Sub-headers resumen CRÉDITO -->
                <th class="text-right text-caption blue lighten-5">Plan</th>
                <template v-for="(concepto, cIdx) in conceptosUnicos">
                  <th
                    :key="'credito-h2-d-' + cIdx"
                    class="text-right text-caption blue lighten-5"
                    style="min-width: 130px">
                    % Desc. {{ concepto }}
                  </th>
                </template>
                <th class="text-right text-caption blue lighten-5 font-weight-bold">Precio Mín.</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(tipo, tIdx) in items" :key="tIdx">
                <td class="font-weight-medium" style="min-width: 220px">
                  {{ tipo.tipoListaPrecio }}
                  <v-chip
                    x-small
                    label
                    outlined
                    class="ml-1"
                    :color="tipo.tipoEstudiante === 'extranjero' ? 'deep-orange' : 'teal'">
                    {{ tipo.tipoEstudiante === 'extranjero' ? 'EXTRANJERO' : 'NACIONAL' }}
                  </v-chip>
                </td>

                <!-- Datos conceptos -->
                <template v-for="(concepto, cIdx) in conceptosUnicos">
                  <td :key="'m-' + tIdx + '-' + cIdx" class="text-right">
                    {{ obtenerDatosConcepto(tipo, concepto).montoCuota }}
                  </td>
                  <td :key="'c-' + tIdx + '-' + cIdx" class="text-right">
                    {{ obtenerDatosConcepto(tipo, concepto).cuotas }}
                  </td>
                  <td :key="'t-' + tIdx + '-' + cIdx" class="text-right font-weight-medium">
                    {{ obtenerDatosConcepto(tipo, concepto).total }}
                  </td>
                </template>

                <!-- Resumen CONTADO -->
                <td class="text-right font-weight-bold green--text text--darken-2">
                  {{ calcularPlanModalidad(tipo, 'contado') }}
                </td>
                <template v-for="(concepto, cIdx) in conceptosUnicos">
                  <td :key="'contado-d-' + tIdx + '-' + cIdx" class="text-right">
                    {{
                      obtenerDatosModalidad(tipo, 'contado', concepto).existe
                        ? obtenerDatosModalidad(tipo, 'contado', concepto).porcentaje + '%'
                        : '-'
                    }}
                  </td>
                </template>
                <td class="text-right font-weight-bold green--text text--darken-2">
                  {{ calcularPrecioMinModalidad(tipo, 'contado') }}
                </td>

                <!-- Resumen CRÉDITO -->
                <td class="text-right font-weight-bold blue--text text--darken-2">
                  {{ calcularPlanModalidad(tipo, 'credito') }}
                </td>
                <template v-for="(concepto, cIdx) in conceptosUnicos">
                  <td :key="'credito-d-' + tIdx + '-' + cIdx" class="text-right">
                    {{
                      obtenerDatosModalidad(tipo, 'credito', concepto).existe
                        ? obtenerDatosModalidad(tipo, 'credito', concepto).porcentaje + '%'
                        : '-'
                    }}
                  </td>
                </template>
                <td class="text-right font-weight-bold blue--text text--darken-2">
                  {{ calcularPrecioMinModalidad(tipo, 'credito') }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { formatearValorAMoneda } from '../../utils/funciones';

export default {
  name: 'TablaPivotPreciosTodosLosTipos',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    conceptosUnicos() {
      const conceptosMap = new Map();

      for (const tipo of this.items) {
        for (const mod of tipo.modalidades) {
          for (const con of mod.conceptos) {
            if (!conceptosMap.has(con.conceptoPago.id)) {
              conceptosMap.set(con.conceptoPago.id, con.conceptoPago.nombre);
            }
          }
        }
      }

      return Array.from(conceptosMap.values());
    },
  },
  methods: {
    formatearValorAMoneda,
    obtenerDatosConcepto(tipo, conceptoNombre) {
      for (const mod of tipo.modalidades) {
        const con = mod.conceptos.find((c) => c.conceptoPago.nombre === conceptoNombre);

        if (con) {
          return {
            montoCuota: formatearValorAMoneda(con.montoCuota),
            cuotas: con.numeroCuotas,
            total: formatearValorAMoneda(con.montoTotal),
          };
        }
      }

      return { montoCuota: '-', cuotas: '-', total: '-' };
    },
    obtenerDatosModalidad(tipo, modalidadPago, conceptoNombre) {
      const mod = tipo.modalidades.find((m) => m.modalidadPago === modalidadPago);

      if (!mod) return { porcentaje: null, existe: false };

      const con = mod.conceptos.find((c) => c.conceptoPago.nombre === conceptoNombre);

      if (!con) return { porcentaje: null, existe: false };

      return { porcentaje: con.porcentajeMaximoDescuento, existe: true };
    },
    calcularPlanModalidad(tipo, modalidadPago) {
      const mod = tipo.modalidades.find((m) => m.modalidadPago === modalidadPago);

      if (!mod) return '-';

      return formatearValorAMoneda(mod.total);
    },
    calcularPrecioMinModalidad(tipo, modalidadPago) {
      const mod = tipo.modalidades.find((m) => m.modalidadPago === modalidadPago);

      if (!mod) return '-';

      return formatearValorAMoneda(mod.totalMinimo);
    },
  },
};
</script>
